import StudySessionCheckoutHeader from 'my-components/StudySession/StudySessionCheckout/StudySessionCheckoutHeader';
import DialogResponsive from 'my-elements/DialogResponsive';

import StudySessionBundleCheckoutConfirmation from './StudySessionBundleCheckoutConfirmation';
import StudySessionBundleCheckoutPayment from './StudySessionBundleCheckoutPayment';

import Box from '@mui/material/Box';

export default function StudySessionBundleCheckout(props) {
  const {
    activeStep,
    confirming,
    course,
    currentUser,
    onChangeStep,
    onClose,
    onPaymentSuccess,
    open,
    pricingInfo,
    studySessionBundle,
    studySessionBundleUser,
  } = props;

  return (
    <DialogResponsive fullWidth onClose={confirming ? undefined : onClose} open={open}>
      <StudySessionCheckoutHeader
        activeStep={activeStep}
        loading={confirming}
        onChangeStep={onChangeStep}
        onClose={onClose}
      />
      {activeStep === 0 ?
        <Box sx={{ px: [2, 8], py: 2, backgroundColor: 'background.default' }}>
          <StudySessionBundleCheckoutPayment
            currentUser={currentUser}
            loading={confirming}
            onClose={onClose}
            onPaymentSuccess={onPaymentSuccess}
            pricingInfo={pricingInfo}
            studySessionBundle={studySessionBundle}
            studySessionBundleUser={studySessionBundleUser}
          />
        </Box>
      : <StudySessionBundleCheckoutConfirmation
          course={course}
          onClose={onClose}
          studySessionBundle={studySessionBundle}
        />
      }
    </DialogResponsive>
  );
}
